// extracted by mini-css-extract-plugin
export default {"subPage":"CompanyView_subPage__TX6GN","anchorSider":"CompanyView_anchorSider__OW+t0","submitItem":"CompanyView_submitItem__vinsc","imgOption":"CompanyView_imgOption__aIZjK"};